import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { formatCurrency } from '../../helper/string'
import { desktop, mobile } from '../../styles/media'
import themeDark from '../../styles/theme-dark'

const CardPriceAmount = ({ amount, currency, dark, isDeck, loading, small }) => (
	<StyledCardPriceAmount
		amount={amount}
		isDeck={isDeck}
		small={small}
		theme={dark ? themeDark : undefined}
		loading={loading ? 1 : undefined}
	>
		{amount !== null && !Number.isNaN(amount) && !loading && formatCurrency(currency, amount)}
		{(amount === null || Number.isNaN(amount)) && !loading && 'n/a'}
	</StyledCardPriceAmount>
)

CardPriceAmount.propTypes = {
	amount: PropTypes.number,
	dark: PropTypes.bool,
	currency: PropTypes.string.isRequired,
	isDeck: PropTypes.bool,
	loading: PropTypes.bool,
	small: PropTypes.bool
}

CardPriceAmount.defaultProps = {
	amount: null,
	dark: false,
	isDeck: false,
	loading: false,
	small: false
}

export const StyledCardPriceAmount = styled.span`
	background: ${props => props.theme.background};
	border-radius: 2px;
    box-shadow: ${props => props.theme.id === 'dark' ? '0 0 3px 1px rgba(100, 100, 100, 0.5)' : '0 0 2px rgba(0, 0, 0, 0.3)'};
	color: ${props => props.theme.textVeryLight};
	font-size: 0.9rem;
	font-weight: 400;
	height: 25px;
	padding: 0 0.5rem;
	white-space: nowrap;
	width: fit-content;

	align-items: center;
	display: flex;
	justify-content: right;

	${props => props.amount === null && `
		font-size: 0.8rem;
		opacity: 0.5;
		justify-content: center;
		min-width: 56px;
	`}

	${props => props.amount >= 100 && `
		background: ${props.theme.background};
		color: ${props.theme.textLight};
	`}

	${props => props.amount >= 500 && `
		background: ${props.theme.background};
		color: ${props.theme.text};
	`}

	${props => props.amount >= 1000 && `
		background: ${props.theme.priceSmall};
		box-shadow: ${props.theme.id === 'dark' ? 'none' : '0 0 2px rgba(0, 0, 0, 0.4)'};
	`}

	${props => props.amount >= 2000 && `
		background: ${props.theme.priceHigh};
		font-weight: 500;
		color: #000;
	`}

	${props => props.amount >= 4000 && `
		font-weight: 600;
	`}

	${props => props.isDeck && `
		background: transparent;
		color: #FFF;
		box-shadow: none;
		font-weight: 500;
		padding: 0;
	`}

	${props => props.loading && `
		opacity: 0.5;
		pointer-events: none;
	`}

	${desktop`
		transition: 0.1s;
	`}

	${mobile`
		${props => props.small && `
			font-size: 0.8rem;
			padding: 0 0.35rem;
			height: 20px;
			min-width: 46px;
		`}
	`}

	${props => props.small && `
		font-size: 0.6rem;
		height: 20px;
		padding: 0 0.35rem;
	`}
`

export default CardPriceAmount
